import { useSelector, useDispatch } from 'react-redux'
import { Plus, Download, X } from 'lucide-react'
import { RootState } from '@/store/store'
import { clearSelection } from '@/store/slices/uiSlice'

function StatusBar() {
  const dispatch = useDispatch()
  const selectedImages = useSelector((state: RootState) => state.ui.selectedImages)

  if (selectedImages.length === 0) {
    return null
  }

  return (
    <div className="h-14 border-t border-border bg-card px-4 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <span className="text-sm text-muted-foreground">
          Selected: <span className="text-foreground font-medium">{selectedImages.length} images</span>
        </span>

        <button
          onClick={() => dispatch(clearSelection())}
          className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1"
        >
          <X size={14} />
          Clear
        </button>
      </div>

      <div className="flex items-center gap-2">
        <button className="flex items-center gap-2 px-3 py-1.5 bg-secondary hover:bg-secondary/80 rounded-md text-sm transition-colors">
          <Plus size={16} />
          Add to Album
        </button>

        <button className="flex items-center gap-2 px-3 py-1.5 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md text-sm transition-colors">
          <Download size={16} />
          Export
        </button>
      </div>
    </div>
  )
}

export default StatusBar
